export class ValueList<T> {

    public static copy<T>(valueList: ValueList<T>) {
        return new ValueList<T>(valueList.values, valueList.defaultValue, valueList.currentValue);
    }

    constructor(public values?: T[], public defaultValue?: T, public currentValue?: T) {
    }
}
